export default __webpack_public_path__ + "static/media/question_mark.3fdf1c48.svg";